import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class modalUraAutenticadora {
  private modalElement: HTMLElement | null = null;
  private modalInterval: any = null;
  private defaultUraMessage : string = 'Cliente transferido para URA autenticadora, aguarde o retorno da ligação em até';
  private defaultUraTimer : number = 120;
  constructor() {}

  public showModalWithTimer(message: string, seconds: number) {
    if (this.modalElement) return;

    const overlay = document.createElement('div');
    overlay.id = 'custom-modal-overlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.background = 'rgba(0,0,0,0.6)';
    overlay.style.zIndex = '9999';
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';

    const modal = document.createElement('div');
    modal.className = 'ids-modal ids-p-4';
    modal.style.background = '#fff';
    modal.style.borderRadius = '8px';
    modal.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
    modal.style.padding = '32px';
    modal.style.minWidth = '320px';
    modal.style.textAlign = 'center';
    modal.style.color = '#222';

    const msg = document.createElement('p');
    msg.className = 'ids-mt-2';
    msg.style.fontSize = '1.2rem';
    msg.innerText = `${message} ${this.formatTime(seconds)}`;
    modal.appendChild(msg);

    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    this.modalElement = overlay;

    let remaining = seconds;
    this.modalInterval = setInterval(() => {
      remaining--;
      msg.innerText = `${message} ${this.formatTime(remaining)}`;
      if (remaining <= 0) {
        this.hideModal();
      }
    }, 1000);
  }

  public hideModal() {
    if (this.modalElement) {
      document.body.removeChild(this.modalElement);
      this.modalElement = null;
    }
    if (this.modalInterval) {
      clearInterval(this.modalInterval);
      this.modalInterval = null;
    }
  }

  private formatTime(seconds: number): string {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  }

  public controlModalWithDefaultMessageAndTimer(agentStatus : string) {
    if (agentStatus === 'Autenticadora') {
      this.showModalWithTimer(this.defaultUraMessage,this.defaultUraTimer);
    } else {
      this.hideModal();
    }
  }
}
